import React, { useState } from 'react'
import { Box, Tab, Tabs, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import MaterialCatalogTab from './MaterialCatalogTab'
import VendorCatalogAdmin from './VendorCatalogAdmin'
import VendorCatalogSearch from './VendorCatalogSearch'
import MappingDashboard from './MappingDashboard'
import AspireItemMapper from './AspireItemMapper'
import EwingSyncPanel from './EwingSyncPanel'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    minHeight: '100vh',
    backgroundColor: 'var(--bg, #fff)'
  },
  header: {
    padding: theme.spacing(2, 3, 0),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  },
  tabs: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(1)
  }
}))

export default function VendorCatalogPage() {
  const classes = useStyles()
  const [tab, setTab] = useState(0)

  return (
    <div className={classes.root}>
      <Box className={classes.header}>
        <Typography variant="h5">Vendor Catalogs</Typography>
      </Box>
      <Tabs
        value={tab}
        onChange={(e, v) => setTab(v)}
        className={classes.tabs}
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab label="Material Catalog" />
        <Tab label="Catalogs" />
        <Tab label="Search" />
        <Tab label="Aspire Items" />
        <Tab label="Mappings" />
        <Tab label="Ewing Sync" />
      </Tabs>
      {tab === 0 && <MaterialCatalogTab />}
      {tab === 1 && <VendorCatalogAdmin />}
      {tab === 2 && <VendorCatalogSearch />}
      {tab === 3 && <AspireItemMapper />}
      {tab === 4 && <MappingDashboard />}
      {tab === 5 && <EwingSyncPanel />}
    </div>
  )
}
